$(function () {
    "use strict";

    /*------ MENU Fixed ------*/
    $(window).scroll(function () {
        var $scroll = $(window).scrollTop();
        var $navbar = $(".navbar");
        var $header = $(".header-icon-bars ");
        if ($scroll > 100) {
            $navbar.addClass("scroll-nav");
            $header.addClass("bar-color");
        } else {
            $navbar.removeClass("scroll-nav");
            $header.removeClass("bar-color");
        }
    });
$('.hamburger').click(function(){
$(this).toggleClass('active');


});
});
// =============== code of subscribe section =============
$(document).ready(function(){
  console.clear();
  $('<div>some text <a class="text">Learn More</a></div>').insertBefore('.yotpo-subscription-benefits-list');
});
